/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addAlarmOntologyExportRequest } from '../fn/reporting/add-alarm-ontology-export-request';
import { AddAlarmOntologyExportRequest$Params } from '../fn/reporting/add-alarm-ontology-export-request';
import { addAnalogicOntologyExportRequest } from '../fn/reporting/add-analogic-ontology-export-request';
import { AddAnalogicOntologyExportRequest$Params } from '../fn/reporting/add-analogic-ontology-export-request';
import { addCallNotificationOntologyExportRequest } from '../fn/reporting/add-call-notification-ontology-export-request';
import { AddCallNotificationOntologyExportRequest$Params } from '../fn/reporting/add-call-notification-ontology-export-request';
import { addEventOntologyExportRequest } from '../fn/reporting/add-event-ontology-export-request';
import { AddEventOntologyExportRequest$Params } from '../fn/reporting/add-event-ontology-export-request';
import { addTicketOntologyExportRequest } from '../fn/reporting/add-ticket-ontology-export-request';
import { AddTicketOntologyExportRequest$Params } from '../fn/reporting/add-ticket-ontology-export-request';
import { addTransactionOntologyExportRequest } from '../fn/reporting/add-transaction-ontology-export-request';
import { AddTransactionOntologyExportRequest$Params } from '../fn/reporting/add-transaction-ontology-export-request';
import { childExportRequest } from '../fn/reporting/child-export-request';
import { ChildExportRequest$Params } from '../fn/reporting/child-export-request';
import { configuredExportRequest } from '../fn/reporting/configured-export-request';
import { ConfiguredExportRequest$Params } from '../fn/reporting/configured-export-request';
import { createExportRequest } from '../fn/reporting/create-export-request';
import { CreateExportRequest$Params } from '../fn/reporting/create-export-request';
import { createExportRequestModel } from '../fn/reporting/create-export-request-model';
import { CreateExportRequestModel$Params } from '../fn/reporting/create-export-request-model';
import { deleteExportRequest } from '../fn/reporting/delete-export-request';
import { DeleteExportRequest$Params } from '../fn/reporting/delete-export-request';
import { deleteExportRequestModel } from '../fn/reporting/delete-export-request-model';
import { DeleteExportRequestModel$Params } from '../fn/reporting/delete-export-request-model';
import { downloadExportRequest } from '../fn/reporting/download-export-request';
import { DownloadExportRequest$Params } from '../fn/reporting/download-export-request';
import { downloadExportRequestModel } from '../fn/reporting/download-export-request-model';
import { DownloadExportRequestModel$Params } from '../fn/reporting/download-export-request-model';
import { downloadExportRequestRustfs } from '../fn/reporting/download-export-request-rustfs';
import { DownloadExportRequestRustfs$Params } from '../fn/reporting/download-export-request-rustfs';
import { duplicateExportRequest } from '../fn/reporting/duplicate-export-request';
import { DuplicateExportRequest$Params } from '../fn/reporting/duplicate-export-request';
import { ExportRequest } from '../models/export-request';
import { ExportRequestGenericOntology } from '../models/export-request-generic-ontology';
import { ExportRequestModel } from '../models/export-request-model';
import { ExportRequestModelPagedList } from '../models/export-request-model-paged-list';
import { ExportRequestPagedList } from '../models/export-request-paged-list';
import { ExportRequestTagOntology } from '../models/export-request-tag-ontology';
import { ExportRequestTransactionOntology } from '../models/export-request-transaction-ontology';
import { FileDownloadResponse } from '../models/file-download-response';
import { getChildOfRequest } from '../fn/reporting/get-child-of-request';
import { GetChildOfRequest$Params } from '../fn/reporting/get-child-of-request';
import { getExportRequest } from '../fn/reporting/get-export-request';
import { GetExportRequest$Params } from '../fn/reporting/get-export-request';
import { getExportRequestAlarmOntology } from '../fn/reporting/get-export-request-alarm-ontology';
import { GetExportRequestAlarmOntology$Params } from '../fn/reporting/get-export-request-alarm-ontology';
import { getExportRequestAnalogicOntology } from '../fn/reporting/get-export-request-analogic-ontology';
import { GetExportRequestAnalogicOntology$Params } from '../fn/reporting/get-export-request-analogic-ontology';
import { getExportRequestCallNotificationOntology } from '../fn/reporting/get-export-request-call-notification-ontology';
import { GetExportRequestCallNotificationOntology$Params } from '../fn/reporting/get-export-request-call-notification-ontology';
import { getExportRequestEventOntology } from '../fn/reporting/get-export-request-event-ontology';
import { GetExportRequestEventOntology$Params } from '../fn/reporting/get-export-request-event-ontology';
import { getExportRequestModel } from '../fn/reporting/get-export-request-model';
import { GetExportRequestModel$Params } from '../fn/reporting/get-export-request-model';
import { getExportRequestOntologies } from '../fn/reporting/get-export-request-ontologies';
import { GetExportRequestOntologies$Params } from '../fn/reporting/get-export-request-ontologies';
import { getExportRequestTicketOntology } from '../fn/reporting/get-export-request-ticket-ontology';
import { GetExportRequestTicketOntology$Params } from '../fn/reporting/get-export-request-ticket-ontology';
import { getExportRequestTransactionOntology } from '../fn/reporting/get-export-request-transaction-ontology';
import { GetExportRequestTransactionOntology$Params } from '../fn/reporting/get-export-request-transaction-ontology';
import { getOntologiesRustfUingOption } from '../fn/reporting/get-ontologies-rustf-uing-option';
import { GetOntologiesRustfUingOption$Params } from '../fn/reporting/get-ontologies-rustf-uing-option';
import { retryExportRequest } from '../fn/reporting/retry-export-request';
import { RetryExportRequest$Params } from '../fn/reporting/retry-export-request';
import { searchExportRequestModels$Any } from '../fn/reporting/search-export-request-models-any';
import { SearchExportRequestModels$Any$Params } from '../fn/reporting/search-export-request-models-any';
import { searchExportRequestModels$Json } from '../fn/reporting/search-export-request-models-json';
import { SearchExportRequestModels$Json$Params } from '../fn/reporting/search-export-request-models-json';
import { searchExportRequests$Any } from '../fn/reporting/search-export-requests-any';
import { SearchExportRequests$Any$Params } from '../fn/reporting/search-export-requests-any';
import { searchExportRequests$Json } from '../fn/reporting/search-export-requests-json';
import { SearchExportRequests$Json$Params } from '../fn/reporting/search-export-requests-json';
import { updateExportRequest } from '../fn/reporting/update-export-request';
import { UpdateExportRequest$Params } from '../fn/reporting/update-export-request';
import { updateExportRequestAlarmOntology } from '../fn/reporting/update-export-request-alarm-ontology';
import { UpdateExportRequestAlarmOntology$Params } from '../fn/reporting/update-export-request-alarm-ontology';
import { updateExportRequestAnalogicOntology } from '../fn/reporting/update-export-request-analogic-ontology';
import { UpdateExportRequestAnalogicOntology$Params } from '../fn/reporting/update-export-request-analogic-ontology';
import { updateExportRequestCallNotificationOntology } from '../fn/reporting/update-export-request-call-notification-ontology';
import { UpdateExportRequestCallNotificationOntology$Params } from '../fn/reporting/update-export-request-call-notification-ontology';
import { updateExportRequestEventOntology } from '../fn/reporting/update-export-request-event-ontology';
import { UpdateExportRequestEventOntology$Params } from '../fn/reporting/update-export-request-event-ontology';
import { updateExportRequestTicketOntology } from '../fn/reporting/update-export-request-ticket-ontology';
import { UpdateExportRequestTicketOntology$Params } from '../fn/reporting/update-export-request-ticket-ontology';
import { updateExportRequestTransactionOntology } from '../fn/reporting/update-export-request-transaction-ontology';
import { UpdateExportRequestTransactionOntology$Params } from '../fn/reporting/update-export-request-transaction-ontology';
import { uploadExportRequestModel } from '../fn/reporting/upload-export-request-model';
import { UploadExportRequestModel$Params } from '../fn/reporting/upload-export-request-model';


/**
 * All about reporting features
 */
@Injectable({ providedIn: 'root' })
export class ReportingService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getOntologiesRustfUingOption()` */
  static readonly GetOntologiesRustfUingOptionPath = '/ontologies/rusfts';

  /**
   * Return Rusfts using option.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOntologiesRustfUingOption()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOntologiesRustfUingOption$Response(params?: GetOntologiesRustfUingOption$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return getOntologiesRustfUingOption(this.http, this.rootUrl, params, context);
  }

  /**
   * Return Rusfts using option.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOntologiesRustfUingOption$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOntologiesRustfUingOption(params?: GetOntologiesRustfUingOption$Params, context?: HttpContext): Observable<boolean> {
    return this.getOntologiesRustfUingOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `getExportRequestOntologies()` */
  static readonly GetExportRequestOntologiesPath = '/export-request/ontologies';

  /**
   * Return a list on possible ontologies.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestOntologies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestOntologies$Response(params?: GetExportRequestOntologies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getExportRequestOntologies(this.http, this.rootUrl, params, context);
  }

  /**
   * Return a list on possible ontologies.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestOntologies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestOntologies(params?: GetExportRequestOntologies$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getExportRequestOntologies$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `createExportRequestModel()` */
  static readonly CreateExportRequestModelPath = '/export-request/model';

  /**
   * Allow to create a model for a demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createExportRequestModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportRequestModel$Response(params: CreateExportRequestModel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createExportRequestModel(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to create a model for a demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createExportRequestModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportRequestModel(params: CreateExportRequestModel$Params, context?: HttpContext): Observable<void> {
    return this.createExportRequestModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchExportRequestModels()` */
  static readonly SearchExportRequestModelsPath = '/export-request/model/search';

  /**
   * Search model for demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchExportRequestModels$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchExportRequestModels$Json$Response(params?: SearchExportRequestModels$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestModelPagedList>> {
    return searchExportRequestModels$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search model for demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchExportRequestModels$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchExportRequestModels$Json(params?: SearchExportRequestModels$Json$Params, context?: HttpContext): Observable<ExportRequestModelPagedList> {
    return this.searchExportRequestModels$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestModelPagedList>): ExportRequestModelPagedList => r.body)
    );
  }

  /**
   * Search model for demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchExportRequestModels$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchExportRequestModels$Any$Response(params?: SearchExportRequestModels$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestModelPagedList>> {
    return searchExportRequestModels$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search model for demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchExportRequestModels$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchExportRequestModels$Any(params?: SearchExportRequestModels$Any$Params, context?: HttpContext): Observable<ExportRequestModelPagedList> {
    return this.searchExportRequestModels$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestModelPagedList>): ExportRequestModelPagedList => r.body)
    );
  }

  /** Path part for operation `getExportRequestModel()` */
  static readonly GetExportRequestModelPath = '/export-request/model/{uid}';

  /**
   * Get a model.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestModel$Response(params: GetExportRequestModel$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestModel>> {
    return getExportRequestModel(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a model.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestModel(params: GetExportRequestModel$Params, context?: HttpContext): Observable<ExportRequestModel> {
    return this.getExportRequestModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestModel>): ExportRequestModel => r.body)
    );
  }

  /** Path part for operation `deleteExportRequestModel()` */
  static readonly DeleteExportRequestModelPath = '/export-request/model/{uid}';

  /**
   * Delete a model.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteExportRequestModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExportRequestModel$Response(params: DeleteExportRequestModel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteExportRequestModel(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a model.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteExportRequestModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExportRequestModel(params: DeleteExportRequestModel$Params, context?: HttpContext): Observable<void> {
    return this.deleteExportRequestModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadExportRequestModel()` */
  static readonly DownloadExportRequestModelPath = '/export-request/model/{uid}/download';

  /**
   * Download a model's excel template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadExportRequestModel()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequestModel$Response(params: DownloadExportRequestModel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadExportRequestModel(this.http, this.rootUrl, params, context);
  }

  /**
   * Download a model's excel template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadExportRequestModel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequestModel(params: DownloadExportRequestModel$Params, context?: HttpContext): Observable<Blob> {
    return this.downloadExportRequestModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `uploadExportRequestModel()` */
  static readonly UploadExportRequestModelPath = '/export-request/model/{uid}/upload';

  /**
   * Upload a model's excel template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadExportRequestModel()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  uploadExportRequestModel$Response(params: UploadExportRequestModel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadExportRequestModel(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a model's excel template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadExportRequestModel$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  uploadExportRequestModel(params: UploadExportRequestModel$Params, context?: HttpContext): Observable<void> {
    return this.uploadExportRequestModel$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createExportRequest()` */
  static readonly CreateExportRequestPath = '/export-request';

  /**
   * Allow to init a demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportRequest$Response(params: CreateExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to init a demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportRequest(params: CreateExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.createExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchExportRequests()` */
  static readonly SearchExportRequestsPath = '/export-request/search';

  /**
   * Search demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchExportRequests$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchExportRequests$Json$Response(params?: SearchExportRequests$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestPagedList>> {
    return searchExportRequests$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchExportRequests$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchExportRequests$Json(params?: SearchExportRequests$Json$Params, context?: HttpContext): Observable<ExportRequestPagedList> {
    return this.searchExportRequests$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestPagedList>): ExportRequestPagedList => r.body)
    );
  }

  /**
   * Search demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchExportRequests$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchExportRequests$Any$Response(params?: SearchExportRequests$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestPagedList>> {
    return searchExportRequests$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search demand of request, sortable and filterable by further fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchExportRequests$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchExportRequests$Any(params?: SearchExportRequests$Any$Params, context?: HttpContext): Observable<ExportRequestPagedList> {
    return this.searchExportRequests$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestPagedList>): ExportRequestPagedList => r.body)
    );
  }

  /** Path part for operation `getExportRequest()` */
  static readonly GetExportRequestPath = '/export-request/{uid}';

  /**
   * Get a simple demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequest$Response(params: GetExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequest>> {
    return getExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequest(params: GetExportRequest$Params, context?: HttpContext): Observable<ExportRequest> {
    return this.getExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequest>): ExportRequest => r.body)
    );
  }

  /** Path part for operation `updateExportRequest()` */
  static readonly UpdateExportRequestPath = '/export-request/{uid}';

  /**
   * Allow to update a demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequest$Response(params: UpdateExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to update a demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequest(params: UpdateExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteExportRequest()` */
  static readonly DeleteExportRequestPath = '/export-request/{uid}';

  /**
   * Delete a simple demand of export; SOFT DELETE.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExportRequest$Response(params: DeleteExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a simple demand of export; SOFT DELETE.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteExportRequest(params: DeleteExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getChildOfRequest()` */
  static readonly GetChildOfRequestPath = '/export-request/{uid}/children';

  /**
   * Get child of request, sortable.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChildOfRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChildOfRequest$Response(params: GetChildOfRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestPagedList>> {
    return getChildOfRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Get child of request, sortable.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getChildOfRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChildOfRequest(params: GetChildOfRequest$Params, context?: HttpContext): Observable<ExportRequestPagedList> {
    return this.getChildOfRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestPagedList>): ExportRequestPagedList => r.body)
    );
  }

  /** Path part for operation `configuredExportRequest()` */
  static readonly ConfiguredExportRequestPath = '/export-request/{uid}/configured';

  /**
   * Valid demand of export's configuration, when all ontologies are configured.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configuredExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  configuredExportRequest$Response(params: ConfiguredExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return configuredExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Valid demand of export's configuration, when all ontologies are configured.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `configuredExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configuredExportRequest(params: ConfiguredExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.configuredExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `duplicateExportRequest()` */
  static readonly DuplicateExportRequestPath = '/export-request/{uid}/duplicate';

  /**
   * Duplicate a demand of export, in order to create a similar demand with some changed parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `duplicateExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  duplicateExportRequest$Response(params: DuplicateExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return duplicateExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Duplicate a demand of export, in order to create a similar demand with some changed parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `duplicateExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  duplicateExportRequest(params: DuplicateExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.duplicateExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `childExportRequest()` */
  static readonly ChildExportRequestPath = '/export-request/{uid}/child';

  /**
   * Child, like duplicate with source as parent, a demand of export, in order to create a similar demand with some changed parameters.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `childExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  childExportRequest$Response(params: ChildExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return childExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Child, like duplicate with source as parent, a demand of export, in order to create a similar demand with some changed parameters.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `childExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  childExportRequest(params: ChildExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.childExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `retryExportRequest()` */
  static readonly RetryExportRequestPath = '/export-request/{uid}/retry';

  /**
   * Retry a demand of export, in some state, we can ask for retry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `retryExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryExportRequest$Response(params: RetryExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return retryExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Retry a demand of export, in some state, we can ask for retry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `retryExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  retryExportRequest(params: RetryExportRequest$Params, context?: HttpContext): Observable<void> {
    return this.retryExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadExportRequestRustfs()` */
  static readonly DownloadExportRequestRustfsPath = '/export-request/{uid}/downloadRustfs';

  /**
   * Download a result of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadExportRequestRustfs()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequestRustfs$Response(params: DownloadExportRequestRustfs$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
    return downloadExportRequestRustfs(this.http, this.rootUrl, params, context);
  }

  /**
   * Download a result of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadExportRequestRustfs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequestRustfs(params: DownloadExportRequestRustfs$Params, context?: HttpContext): Observable<FileDownloadResponse> {
    return this.downloadExportRequestRustfs$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDownloadResponse>): FileDownloadResponse => r.body)
    );
  }

  /** Path part for operation `downloadExportRequest()` */
  static readonly DownloadExportRequestPath = '/export-request/{uid}/download';

  /**
   * Download a result of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadExportRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequest$Response(params: DownloadExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Download a result of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadExportRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadExportRequest(params: DownloadExportRequest$Params, context?: HttpContext): Observable<Blob> {
    return this.downloadExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `addAlarmOntologyExportRequest()` */
  static readonly AddAlarmOntologyExportRequestPath = '/export-request/{uid}/ontology/alarm';

  /**
   * Add a simple alarm ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAlarmOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAlarmOntologyExportRequest$Response(params: AddAlarmOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return addAlarmOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple alarm ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAlarmOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAlarmOntologyExportRequest(params: AddAlarmOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.addAlarmOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestAlarmOntology()` */
  static readonly GetExportRequestAlarmOntologyPath = '/export-request/{uid}/ontology/alarm/{ontologyUid}';

  /**
   * Get a simple alarm ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestAlarmOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAlarmOntology$Response(params: GetExportRequestAlarmOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return getExportRequestAlarmOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple alarm ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestAlarmOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAlarmOntology(params: GetExportRequestAlarmOntology$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.getExportRequestAlarmOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestAlarmOntology()` */
  static readonly UpdateExportRequestAlarmOntologyPath = '/export-request/{uid}/ontology/alarm/{ontologyUid}';

  /**
   * Update a simple alarm ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestAlarmOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAlarmOntology$Response(params: UpdateExportRequestAlarmOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestAlarmOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple alarm ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestAlarmOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAlarmOntology(params: UpdateExportRequestAlarmOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestAlarmOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addAnalogicOntologyExportRequest()` */
  static readonly AddAnalogicOntologyExportRequestPath = '/export-request/{uid}/ontology/analogic';

  /**
   * Add a simple analogic ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAnalogicOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAnalogicOntologyExportRequest$Response(params: AddAnalogicOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
    return addAnalogicOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple analogic ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAnalogicOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAnalogicOntologyExportRequest(params: AddAnalogicOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestTagOntology> {
    return this.addAnalogicOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTagOntology>): ExportRequestTagOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestAnalogicOntology()` */
  static readonly GetExportRequestAnalogicOntologyPath = '/export-request/{uid}/ontology/analogic/{ontologyUid}';

  /**
   * Get a simple analogic ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestAnalogicOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAnalogicOntology$Response(params: GetExportRequestAnalogicOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
    return getExportRequestAnalogicOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple analogic ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestAnalogicOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestAnalogicOntology(params: GetExportRequestAnalogicOntology$Params, context?: HttpContext): Observable<ExportRequestTagOntology> {
    return this.getExportRequestAnalogicOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTagOntology>): ExportRequestTagOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestAnalogicOntology()` */
  static readonly UpdateExportRequestAnalogicOntologyPath = '/export-request/{uid}/ontology/analogic/{ontologyUid}';

  /**
   * Update a simple analogic ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestAnalogicOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAnalogicOntology$Response(params: UpdateExportRequestAnalogicOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestAnalogicOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple analogic ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestAnalogicOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestAnalogicOntology(params: UpdateExportRequestAnalogicOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestAnalogicOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addCallNotificationOntologyExportRequest()` */
  static readonly AddCallNotificationOntologyExportRequestPath = '/export-request/{uid}/ontology/call-notification';

  /**
   * Add a simple call notification ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCallNotificationOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCallNotificationOntologyExportRequest$Response(params: AddCallNotificationOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return addCallNotificationOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple call notification ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCallNotificationOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addCallNotificationOntologyExportRequest(params: AddCallNotificationOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.addCallNotificationOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestCallNotificationOntology()` */
  static readonly GetExportRequestCallNotificationOntologyPath = '/export-request/{uid}/ontology/call-notification/{ontologyUid}';

  /**
   * Get a simple call notification ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestCallNotificationOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestCallNotificationOntology$Response(params: GetExportRequestCallNotificationOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return getExportRequestCallNotificationOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple call notification ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestCallNotificationOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestCallNotificationOntology(params: GetExportRequestCallNotificationOntology$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.getExportRequestCallNotificationOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestCallNotificationOntology()` */
  static readonly UpdateExportRequestCallNotificationOntologyPath = '/export-request/{uid}/ontology/call-notification/{ontologyUid}';

  /**
   * Update a simple call notification ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestCallNotificationOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestCallNotificationOntology$Response(params: UpdateExportRequestCallNotificationOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestCallNotificationOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple call notification ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestCallNotificationOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestCallNotificationOntology(params: UpdateExportRequestCallNotificationOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestCallNotificationOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addEventOntologyExportRequest()` */
  static readonly AddEventOntologyExportRequestPath = '/export-request/{uid}/ontology/event';

  /**
   * Add a simple avent ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addEventOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEventOntologyExportRequest$Response(params: AddEventOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
    return addEventOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple avent ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addEventOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addEventOntologyExportRequest(params: AddEventOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestTagOntology> {
    return this.addEventOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTagOntology>): ExportRequestTagOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestEventOntology()` */
  static readonly GetExportRequestEventOntologyPath = '/export-request/{uid}/ontology/event/{ontologyUid}';

  /**
   * Get a simple event ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestEventOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestEventOntology$Response(params: GetExportRequestEventOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
    return getExportRequestEventOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple event ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestEventOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestEventOntology(params: GetExportRequestEventOntology$Params, context?: HttpContext): Observable<ExportRequestTagOntology> {
    return this.getExportRequestEventOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTagOntology>): ExportRequestTagOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestEventOntology()` */
  static readonly UpdateExportRequestEventOntologyPath = '/export-request/{uid}/ontology/event/{ontologyUid}';

  /**
   * Update a simple event ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestEventOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestEventOntology$Response(params: UpdateExportRequestEventOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestEventOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple event ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestEventOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestEventOntology(params: UpdateExportRequestEventOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestEventOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addTicketOntologyExportRequest()` */
  static readonly AddTicketOntologyExportRequestPath = '/export-request/{uid}/ontology/ticket';

  /**
   * Add a simple ticket ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTicketOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTicketOntologyExportRequest$Response(params: AddTicketOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return addTicketOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple ticket ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTicketOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTicketOntologyExportRequest(params: AddTicketOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.addTicketOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestTicketOntology()` */
  static readonly GetExportRequestTicketOntologyPath = '/export-request/{uid}/ontology/ticket/{ontologyUid}';

  /**
   * Get a simple ticket ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestTicketOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestTicketOntology$Response(params: GetExportRequestTicketOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestGenericOntology>> {
    return getExportRequestTicketOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple ticket ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestTicketOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestTicketOntology(params: GetExportRequestTicketOntology$Params, context?: HttpContext): Observable<ExportRequestGenericOntology> {
    return this.getExportRequestTicketOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestGenericOntology>): ExportRequestGenericOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestTicketOntology()` */
  static readonly UpdateExportRequestTicketOntologyPath = '/export-request/{uid}/ontology/ticket/{ontologyUid}';

  /**
   * Update a simple ticket ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestTicketOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestTicketOntology$Response(params: UpdateExportRequestTicketOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestTicketOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple ticket ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestTicketOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestTicketOntology(params: UpdateExportRequestTicketOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestTicketOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addTransactionOntologyExportRequest()` */
  static readonly AddTransactionOntologyExportRequestPath = '/export-request/{uid}/ontology/transaction';

  /**
   * Add a simple transaction ontology on demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTransactionOntologyExportRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTransactionOntologyExportRequest$Response(params: AddTransactionOntologyExportRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTransactionOntology>> {
    return addTransactionOntologyExportRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a simple transaction ontology on demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTransactionOntologyExportRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTransactionOntologyExportRequest(params: AddTransactionOntologyExportRequest$Params, context?: HttpContext): Observable<ExportRequestTransactionOntology> {
    return this.addTransactionOntologyExportRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTransactionOntology>): ExportRequestTransactionOntology => r.body)
    );
  }

  /** Path part for operation `getExportRequestTransactionOntology()` */
  static readonly GetExportRequestTransactionOntologyPath = '/export-request/{uid}/ontology/transaction/{ontologyUid}';

  /**
   * Get a simple transaction ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportRequestTransactionOntology()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestTransactionOntology$Response(params: GetExportRequestTransactionOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTransactionOntology>> {
    return getExportRequestTransactionOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a simple transaction ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportRequestTransactionOntology$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportRequestTransactionOntology(params: GetExportRequestTransactionOntology$Params, context?: HttpContext): Observable<ExportRequestTransactionOntology> {
    return this.getExportRequestTransactionOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExportRequestTransactionOntology>): ExportRequestTransactionOntology => r.body)
    );
  }

  /** Path part for operation `updateExportRequestTransactionOntology()` */
  static readonly UpdateExportRequestTransactionOntologyPath = '/export-request/{uid}/ontology/transaction/{ontologyUid}';

  /**
   * Update a simple transaction ontology of demand of export.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportRequestTransactionOntology()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestTransactionOntology$Response(params: UpdateExportRequestTransactionOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateExportRequestTransactionOntology(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a simple transaction ontology of demand of export.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExportRequestTransactionOntology$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportRequestTransactionOntology(params: UpdateExportRequestTransactionOntology$Params, context?: HttpContext): Observable<void> {
    return this.updateExportRequestTransactionOntology$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
